import React from 'react'
import { TouchableOpacity, ViewStyle } from 'react-native'

interface CardProps {
  children?: React.ReactNode
  style?: ViewStyle
  disabled?: boolean
  onPress?: any
  dataSet?: any
}
export const Card = (props: CardProps) => {
  const { children, dataSet, style, onPress, disabled } = props

  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={dataSet}
      disabled={Boolean(disabled)}
      onPress={onPress ? onPress : () => {}}
      style={{ ...ROOT, ...style }}
    >
      {children}
    </TouchableOpacity>
  )
}

const ROOT: ViewStyle = {
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
  justifyContent: 'space-evenly',
  alignSelf: 'center',
  width: '100%',
  height: '100%',
  borderWidth: 1,
  borderColor: '#EFF0F6',
  borderRadius: 20,
  backgroundColor: '#fff',
  padding: 20,
  elevation: 2,
}
